import { render, staticRenderFns } from "./postThreads.vue?vue&type=template&id=172018e0&"
import script from "./postThreads.vue?vue&type=script&lang=js&"
export * from "./postThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports